module.exports = __webpack_public_path__ + "img/realestate_pf_overview_icon01.d4982b51.svg";